'use strict';
	//MENU - OPEN
	//MENU - CLOSE
	// APPLY FORM BUTTON
	// SCROLL ANIMATION FUNC
	// SAME HEIGHT FUNCTION
	// IN THE MIDDLE
	// ADDING ACTIVE TO MENUS
	// APPLICATION RETURN BUTTON VISIBLE
	// TESTIMONIALS CAROUSEL
	// IN THE MIDDLE FUNCTION
	// CHECK HEADER SCROLLTOP

if(window.addEventListener) {
	window.addEventListener('load', websiteLoad);
} else if(window.attachEvent) {
	window.attachEvent('load', websiteLoad);
} else {
	window.onload = websiteLoad;
}
//websiteLoad();
function websiteLoad() {
	
	resizableElements();

	

	//MENU - OPEN
	var menuBtnOpen = document.getElementById('menu-main');
	var menuBtnOpenSlideHeader = document.getElementById('menu-main-mobile');
	var attachButton = false;
	if((menuBtnOpen != null) || (menuBtnOpen != undefined)) {
		var sitenav = document.getElementById('site-menu');
		if(menuBtnOpen.addEventListener) {
			menuBtnOpen.addEventListener('click', menuBtnOpenFunc);
		} else if(menuBtnOpen.attachEvent) {
			menuBtnOpen.attachEvent('click', menuBtnOpenFunc);
		} else {
			menuBtnOpen.onclick = menuBtnOpenFunc;
		}
	}
	if((menuBtnOpenSlideHeader != null) || (menuBtnOpenSlideHeader != undefined)) {
		var sitenavSlide = document.getElementById('site-menu-slided');
		if(menuBtnOpenSlideHeader.addEventListener) {
			menuBtnOpenSlideHeader.addEventListener('click', menuBtnOpenFunc);
		} else if(menuBtnOpenSlideHeader.attachEvent) {
			menuBtnOpenSlideHeader.attachEvent('click', menuBtnOpenFunc);
		} else {
			menuBtnOpenSlideHeader.onclick = menuBtnOpenFunc;
		}
	}


	
	function menuBtnOpenFunc() {
		var menuBtnOpenClass = menuBtnOpen.classList;
		var sitenavClass = sitenav.classList;

		// Sliding header 
		var menuBtnOpenSlidedClass = menuBtnOpenSlideHeader.classList;
		var sitenavSlidedClass = sitenavSlide.classList;

		if((menuBtnOpenClass != null)
			&& (sitenavClass != null)
			&& (menuBtnOpenClass != undefined)
			&& (sitenavClass != undefined)

			//Checks the sliding header 
			&& (sitenavSlidedClass != undefined)
			&& (sitenavSlidedClass != null)
			&& (menuBtnOpenSlidedClass != undefined)
			&& (menuBtnOpenSlidedClass != null)) {

				if( menuBtnOpen.classList.contains('mobile-open') || menuBtnOpenSlideHeader.classList.contains('mobile-open')) {
					//main header
					sitenav.classList.remove('site-menu-opened');
					menuBtnOpen.classList.remove('mobile-open');

					//sliding header
					sitenavSlide.classList.remove('site-menu-opened');
					menuBtnOpenSlideHeader.classList.remove('mobile-open');
				} else {
					//main header
					sitenav.classList.add('site-menu-opened');
					menuBtnOpen.classList.add('mobile-open');

					//sliding header
					sitenavSlide.classList.add('site-menu-opened');
					menuBtnOpenSlideHeader.classList.add('mobile-open');
				}
		} else {
			/* IE 9 Support */
			var menuhasClass = (" " + menuBtnOpen.className + " ").indexOf(" mobile-open ") > -1;
			if(menuhasClass == true) {
				console.log('IE remove');
				//main header
				sitenav.className = sitenav.className.replace(new RegExp('(?:^|\\s)'+ 'site-menu-opened' + '(?:\\s|$)'), ' ');
				menuBtnOpen.className = menuBtnOpen.className.replace(new RegExp('(?:^|\\s)'+ 'mobile-open' + '(?:\\s|$)'), ' ');

				//sliding header
				sitenavSlide.className = sitenavSlide.className.replace(new RegExp('(?:^|\\s)'+ 'site-menu-opened' + '(?:\\s|$)'), ' ');
				menuBtnOpenSlideHeader.className = menuBtnOpenSlideHeader.className.replace(new RegExp('(?:^|\\s)'+ 'mobile-open' + '(?:\\s|$)'), ' ');
			} else {
				console.log('IE open');
				//main header
				sitenav.className += " site-menu-opened ";
				menuBtnOpen.className += " mobile-open ";
				//sliding header
				sitenavSlide.className += " site-menu-opened ";
				menuBtnOpenSlideHeader += " mobile-open ";
			}
		}
	}
	

	// JOBS PAGE AND CATEGORY PAGES - VIEW ALL JOBS BUTTON
	var viewAllbtn = document.getElementById('all_jobs');
	if(viewAllbtn != undefined) {
		var jobsCount = document.getElementsByClassName('loop-jobs');
		if(jobsCount.length < 6) {
			viewAllbtn.style.display = 'none';
		} else {
			viewAllbtn.style.display = 'inline-block';
		}
	}


	// ADDING ACTIVE TO MENUS
	var checkSinglePeople = document.querySelectorAll('body.single-people');
	if(checkSinglePeople.length > 0) {
		/* get menu & submenu items */
		var menuAbout = document.querySelectorAll('.menu-item-29');
		var submenuTeams = document.querySelectorAll('.menu-item-70');

		addToElement(menuAbout, 'current-page-ancestor');
		addToElement(submenuTeams, 'current-menu-item');
	}

	var checkSinglePost = document.querySelectorAll('body.single-post');
	if(checkSinglePost.length > 0) {
		var menuNews = document.querySelectorAll('.menu-item-30');
		/* sets menu active class */
		addToElement(menuNews, 'current-page-ancestor');
	}

	var checkSingleJob = document.querySelectorAll('body.single-jobs');
	if(checkSingleJob.length > 0) {
		var menuJobs = document.querySelectorAll('.menu-item-28');
		/* sets menu active class */
		addToElement(menuJobs, 'current-page-ancestor');
	}

	function addToElement(getArr, getClass) {
		/* sets menu active class */
		for(var i=0; i < getArr.length; i++ ) {
			var elClassList = getArr[i].classList;
			if(elClassList != undefined) {
				getArr[i].classList.add(getClass);
			} else {
				getArr[i].className += ' '+getClass+' ';
			}
		}
	}

	// APPLICATION RETURN BUTTON VISIBLE
	var returnJobsBtn = document.getElementById('returnToJobs');
	var submitJobsBtn = document.querySelector('.single-post-jobs .jobs-content .apply-form input[type="submit"]');
	if((returnJobsBtn != undefined) && (submitJobsBtn != undefined)) {
		submitJobsBtn.parentNode.insertBefore(returnJobsBtn, submitJobsBtn);
		returnJobsBtn.style.display = "inline-block";
	}


	

	var slideDown = document.getElementById('slideDown');
	if(slideDown != undefined) {
		slideDown.addEventListener('click', function() {
			var header_h = document.querySelector('section.hero-header').clientHeight;
			if((header_h != undefined) && (header_h > 0)) {
				scrollingTo(document.documentElement, header_h , 600);
			}
		});
	}

	// SCROLL ANIMATION FUNC
	function scrollingTo(element, to, duration) {

		var start = element.scrollTop,
				change = to - start,
				currentTime = 0,
				increment = 20;
		var animateScroll = function(){        
	        currentTime += increment;
	        var val = Math.easeInOutQuad(currentTime, start, change, duration);
	        element.scrollTop = val;
	        if(currentTime < duration) {
	            setTimeout(animateScroll, increment);
	        }
	    };
	    animateScroll();
	}
	Math.easeInOutQuad = function (t, b, c, d) {
	  t /= d/2;
		if (t < 1) return c/2*t*t + b;
		t--;
		return -c/2 * (t*(t-2) - 1) + b;
	};
	
	// REMOVE GOOGLE MAP FILTER
	var gMap = document.getElementById('map');
	if(gMap != null) {
		/*document.querySelector('.hero-header .filter-overlay').onclick = function() {
			this.style.display = 'none';
		}*/
	}
} // end websiteLoad



/* WINDOW RESIZE */
if(window.addEventListener) {
	window.addEventListener('resize', windowScale);
} else if(window.attachEvent) {
	window.attachEvent('resize', windowScale);
} else {
	window.onresize = windowScale;
}
function windowScale() {
	resizableElements();
}

function resizableElements() {
	// IN THE MIDDLE ON RESIZE
	var excerptImg = document.querySelectorAll('.page-excerpt .page-excerpt-image');
	var excerptContent = document.querySelectorAll('.page-excerpt .page-excerpt-container');
	var winWidth = window.innerWidth;

	if((excerptImg.length > 0) && (excerptContent.length > 0)) {
		for(var expage = 0; expage < excerptContent.length; expage++) {
			inTheMid(excerptImg[expage], excerptContent[expage], winWidth);
		}
	}

	// SAME HEIGHT
	var loop_jobs_titles = document.querySelectorAll('.loop-jobs .loop-jobs-container .loop-jobs-container-inner');
	if(loop_jobs_titles.length > 0) {
		setTimeout(function() {
			sameHeight(loop_jobs_titles, 768);
		}, 1000);
	}

	var loop_posts = document.querySelectorAll('.loop-posts .posts-container');
	if(loop_posts.length > 0) {
		sameHeight(loop_posts, 768);
	}

	var testimonials_block = document.querySelectorAll('.single-testimonial .testimonial-content');
	if(testimonials_block.length > 0) {
		setTimeout(function() {
			sameHeight(testimonials_block, 300);
		}, 1000);
	}
}


/* WINDOW SCROLL */
if(window.addEventListener) {
	window.addEventListener('scroll', websiteScroll);
} else if(window.attachEvent) {
	window.attachEvent('scroll', websiteScroll);
} else {
	window.onscroll = websiteScroll;
}
function websiteScroll() {


}




// SAME HEIGHT FUNCTION
function sameHeight(el, px) {
	if((el.length > 0) && (el != undefined)) {
		var win_w = window.innerWidth;
		if(win_w > px) {
			var mh = [];
			for(var i=0; i<el.length; i++) {
				el.item(i).style.height = 'auto';
				mh.push(el.item(i).offsetHeight);
			}

			gmh = Math.max.apply(null, mh);
			if(gmh != undefined) {
				for(var ii=0; ii<el.length; ii++) {
					el.item(ii).style.height = parseInt(gmh) + 'px';
				}
			}
		}
	}
}

// IN THE MIDDLE FUNCTION
function inTheMid(parent, children, winWidth) {
	var parent_h = parent.clientHeight;
	var children_h = children.clientHeight;
	var childrenTop = (parent_h / 2) - (children_h * 0.5);
	if(winWidth > 992) {
		if(childrenTop > 0) {
			return children.style.top = childrenTop + 'px';
		} else {
			return children.style.top = 0 + 'px';
		}
	} else {
		return children.style.top = 0 + 'px';
	}
}



// GOOGLE MAP INNIT
window.marker = null; 
function initialize() {
	var map;
	var nottingham = new google.maps.LatLng(51.5242551, -0.0825805);
	var style = [ 
		{ "featureType": "road", 
		   "elementType": 
		   "labels.icon", 
		   "stylers": [ 
			  { "saturation": 1 }, 
			  { "gamma": 1 }, 
			  { "visibility": "on" }, 
			  { "hue": "#e6ff00" }
		   ] 
		},
		{ "elementType": "geometry", "stylers": [ 
			{ "saturation": -100 } 
		  ] 
		} 
	];
	var mapOptions = {
		// SET THE CENTER
		center: nottingham,
		// SET THE MAP STYLE & ZOOM LEVEL
		mapTypeId: google.maps.MapTypeId.ROADMAP,
		zoom:16,
		// SET THE BACKGROUND COLOUR
		backgroundColor:"#eeeeee",
		// REMOVE ALL THE CONTROLS EXCEPT ZOOM
		panControl:false,
        scrollwheel: false,
		zoomControl:false,
		mapTypeControl:false,
		scaleControl:false,
		streetViewControl:false,
		overviewMapControl:false,
		zoomControlOptions: {
			style:google.maps.ZoomControlStyle.SMALL
		}
	}
	map = new google.maps.Map(document.getElementById('map'), mapOptions);

	// SET THE MAP TYPE
	// var mapType = new google.maps.StyledMapType(style, {name:"Grayscale"});    
	// map.mapTypes.set('grey', mapType);
	// map.setMapTypeId('grey');

	//CREATE A CUSTOM PIN ICON
	var marker_image ='../wp-content/themes/masonblake/assets/images/map-logo.png';
	//var pinIcon = new google.maps.MarkerImage(marker_image,null,null, null,new google.maps.Size(36, 46));    

	marker = new google.maps.Marker({
	  position: nottingham,
	  map: map,
	  //icon: pinIcon
	});
}
if(document.getElementById('map') != null) {
	google.maps.event.addDomListener(window, 'load', initialize);
}


(function($) {
	$(document).ready(function() {
		$('.multi-item-carousel').carousel({
		  interval: 3000,
		});
		var win_w = $(window).width();
		if(win_w > 992) {
			$('.multi-item-carousel .item').each(function(){
			  var next = $(this).next();
			  if (!next.length) {
			    next = $(this).siblings(':first');
			  }
			  next.children(':first-child').clone().appendTo($(this));
			  
			  if (next.next().length>0) {
			    next.next().children(':first-child').clone().appendTo($(this));
			  } else {
			  	$(this).siblings(':first').children(':first-child').clone().appendTo($(this));
			  }
			});
		}
	});	  
})(jQuery);
